import React, { Component, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import allApplicationDropdown from '../../dependencies/utils/json/allApplicationDropdown.json'
import { connect } from 'react-redux';
import columns, { rowStyle2 } from './common/dependencies/seedfundTableColumn';
import Table from '../common/Table';
import './scss/index.scss';
import ActionModal from './modal';
import popArchiveIcon from '../../assests/images/pop-archive.png';
import popApprovedIcon from '../../assests/images/pop-check.png';
import Download from '../common/Download';
import SectionTitle from '../common/sectionTitle/sectionTitle';
import SearchBox from '../common/Search';
import { SearchByStartupApplicationOptions } from './common/constant';
import InputField from '../common/InputField';
import { getSeedfundReportList, doDownloadResultList, lastGeneratedReportHistory } from '../../dependencies/services/beneficiary';
import Button from '../common/Button';
import downArrowBtn from '../../assests/images/down-arrow-btn.png';
import downArrowBtnblack from '../../assests/images/down-arrow-btn-black.png';
import { toast } from "react-toastify";
import Refresh from '../common/Refresh';
import { ROLES } from '../../constants/Roles';
import { storage } from '../../dependencies/store/storage';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';

const SeedFund = (props) => {

  const { getSeedfundReportList, seedfundReportDataState: { data, recordsTotal,status,message }, doDownloadResultList, lastGeneratedReportHistory } = props;
  const [sortField, setSortField] = useState('applicationDate');
  const [sortOrder, setSortOrder] = useState('DESC');
  const [sizePerPage, setSizePerPage] = useState(20);

  const [dropDownStatus, setDropDownStatus] = useState('text');
  const [edited, setEdited] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [query, setQuery] = useState({
    seedFunded: true, archived: false, edited: null
  });
  const [searchParams, setSearchParams] = useState({});
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [checkedValue, setCheckedValue] = useState([]);
  const [modalValue, setModalValue] = useState(false);
  const [buttonValue, setButtonValue] = useState('');
  const [bulkValue, setBulkValue] = useState({});
  const [natureOption, SetNatureOption] = useState([]);
  const [actionType, setActionType] = useState('');
  const [newApplication, setNewApplication] = useState(false);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showIncompleteHistory, setShowIncompleteHistory] = useState(false);
  const [exemptionId, setExemptionId] = useState("");
  const [diiptNumber, setDiiptNumber] = useState('');
  const [error, setError] = useState('');
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] = useState(false);
  const [seedfundResultView, setSeedfundResultView] = useState(false);
//   const [openSelectDropdown, setOpenSelectDropdown] = useState(false);
//   const [openNSAYearDropdown, setOpenNSAYearDropdown] = useState(false);
//   const [openSelectFilterDropdown, setOpenSelectFilterDropdown] = useState(false);
//   const [openNSAYearFilterDropdown, setOpenNSAYearFilterDropdown] = useState(false);
//   const [selectFilter, setSelectFilter] = useState('Select By');
//   const [nsaYearFilter, setNsaYearFilter] = useState('NSA Year');
  const [select, setSelect] = useState('Select By');
  const [seedfundYear, setSeedfundYear] = useState('NSA Year');
  const [searchDisable, setSearchDisable] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [nameOfEntity, setNameOfEntity] = useState('');
  const [incorporationNumber, setIncorporationNumber] = useState('');
  const [incorporationDate, setIncorporationDate] = useState('');
  const [certificateNumber, setCertificateNumber] = useState('');
  const [historyData, setHistoryData] = useState({});
  const [openHistory, setOpenHistory] = useState(false);

  const userRole = storage.getUserRole();


  useEffect(() => {
    getTableData();
  }, [sortField, sortOrder, sizePerPage, pageNo, searchParams, query, searchText])

  const getTableData = () => {
    getSeedfundReportList({
      sortColumn: sortField,
      sortOrder: sortOrder.toUpperCase(),
      pageSize: sizePerPage,
      pageIndex: pageNo,
      query
    });
  }

  const onSelectRows = (selectedRows) => {
    setCheckedValue(selectedRows)
  }

  const onSortChange = async (params) => {
    const { order, dataField } = params;
    const newOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC';
    let sortName = '';
    if (dataField === 'mobileNumber') {
      sortName = 'representative.mobile';
    } else if (dataField === 'referenceNumber') {
      sortName = 'referenceNumber';
    } else if (dataField === 'certificateNumber') {
      sortName = 'startupEntity.recognitionNumber';
    } else if (dataField === 'incorporationNumber') {
      sortName = 'incorporationNumber';
    } else if (dataField === 'nameOfEntity') {
      sortName = 'startupEntity.name';
    } else if (dataField === 'applicationDate') {
      sortName = 'applicationDate';
    } else if (dataField === 'registrationDate') {
      sortName = 'startupEntity.corCreatedDate';
    } else if (dataField === 'emailId') {
      sortName = 'representative.email';
    } else {
      sortName = 'createdDate';
    }
    if (dataField !== '') {
      setSortField(sortName);
      setSortOrder(newOrder);
    }

  }
  const handleOnPageChange = (params) => {
    const { page } = params;
    setPageNo(page - 1);
  }
  const handleOnSizePerPageChange = (params) => {
    const { sizePerPage } = params;
    setSizePerPage(sizePerPage)
    setPageNo(0);
  }

  useEffect(() => {
    if (data && status) {
      setNameOfEntity(data[0]?.nameOfEntity);
      setIncorporationDate(data[0]?.incorporationDate);
      setIncorporationNumber(data[0]?.incorporationNumber);
      setCertificateNumber(data[0]?.certificateNumber);
    }
  else{
    toast.error(message)
  }

  }, [data])

  const toggleActionModal = () => {
    setModalValue(!modalValue);
    if (modalValue) {
      setActionType('');
    }
  }

  const actionHandler = (actionType) => {
    setActionType(actionType)
  }
  useEffect(() => {
    if (checkedValue.length === 0 && actionType) {
      setButtonValue('invalid')
      toggleActionModal();
    } else {
      bulkApprove();
    }
  }, [actionType])

  const bulkApprove = () => {
    if (actionType === 'approved') {
      toggleActionModal();
      setButtonValue('approved')
      setBulkValue({
        ids: checkedValue,
        status: 'APPROVE'
      })
    } else if (actionType === 'archived') {
      toggleActionModal();
      setButtonValue('archived')
      setBulkValue({
        ids: checkedValue,
        status: 'ARCHIVE'
      })
    }

  }
  function downloadSeedfundResultList() {
    if (doDownloadResultList) {
      return doDownloadResultList({
        fetchAllRecords: true,
        sortColumn: sortField,
        sortOrder: sortOrder.toUpperCase(),
        pageSize: sizePerPage,
        pageIndex: pageNo,
        query
      }).then((data) => {
        return data;
      })
    }
  }

  const openHistoryModal = async () => {
    setOpenHistory(true);
  }

  const closeHistoryModal = () => {
      setOpenHistory(false);
  }

  useEffect(() => {
    if (props.getSectorOptions) {
      props.getSectorOptions().then((response) => {
        const { data = [] } = response;
        let options = [];
        if (data && data instanceof Array) {
          options = data.reduce((arr, option) => {
            if (option['industryName'] !== null) {
              var text = `${option['sectionName']} (${option['industryName']})` || "";
            } else {
              var text = `${option['sectionName']}` || "";
            }
            const value = option['id'] || "";
            arr.push({ text, value });
            return arr;
          }, []);
        }
        setSectorOptions(options);
      });
    }

    // getNatureOfList().then((response) => {
    //   const { data, status } = response || {};
    //   if (status) {
    //     let options = [];
    //     if (data && data instanceof Array) {
    //       options = data.reduce((arr, option) => {
    //         const text = option['name'] || "";
    //         const value = option['id'] || "";
    //         arr.push({ text, value });
    //         return arr;
    //       }, []);
    //     }
    //     SetNatureOption(options);
    //   }
    // });

  }, [])

  useEffect(() => {
    if (exemptionId) {
      setShowIncompleteHistory(true)
    }
  }, [exemptionId]);
  const clickOnAction = (id) => {
    if (id) {
      setExemptionId(id)
    }
  }
//   useEffect(() => {
//     if (selectFilter != 'Select By' && nsaYearFilter != 'NSA Year') {
//       setSearchDisable(false)
//     }
//   }, [nsaYearFilter, selectFilter])

//   useEffect(() => {
//     if (select != 'Select By' && nsaYear != 'NSA Year') {
//       setSaveDisable(false)
//     }
//   }, [nsaYear, select])

  const handleSearch = () => {
    setSelect('Select By');
    setSeedfundYear('Seedfunded Year');
    setSaveDisable(true);
    setCertificateNumber('');
    setIncorporationDate('');
    setIncorporationNumber('');
    setNameOfEntity('');
    if (diiptNumber) {
      setError('');
      setQuery(() => {
        query.randomReg = diiptNumber
        delete query['status'];
        delete query['seedFunded'];
        return { ...query, 'searchType': 'CREATED_DATE', }
      });
      setSearchText(searchText);
      setPageNo(0);
      setSeedfundResultView(true)
    } else {
      setHasInvalidSubmitOccurred(true)
      setError("Please enter Recognition number")
    }
  }
  const handleInput = (e, name) => {
    let value = e.target.value;

    if (name === 'diiptNumber') {
      setDiiptNumber(value);
    }
  }

  function refreshStatupList() {
    window.location.reload();
  }

  return (

    <div>
      <SectionTitle>Seedfund</SectionTitle>
      <div className="startup-app-filter-form-results">
        <div className='row ju results-row'>
          <div className='col-md-5 w-100'>
            {userRole === ROLES.SUPER_ADMIN && <>
              <div className="inner-wrap clearfix">
                <div className="left-filter-wrap">
                  {/* <div className='nsa-results'>
                    <div className='nsa-results-grup'>
                      <div className='nsa-results-no'>
                      Recognition No
                      </div>
                      <InputField
                        required
                        type="text"
                        name="diiptNumber"
                        //  label="DIPP Number"
                        value={diiptNumber}
                        onChange={handleInput}
                        containerClass={"form-group"}
                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                        error={error}
                      />
                    </div>
                  </div>
                  <div className={`button-wrap`}>
                    <Button
                      className={`bttn`}
                      type="submit"
                      text="Submit"
                      onClick={handleSearch}

                    />
                  </div> */}
                  <div>
                    <button className='history-btn' onClick={openHistoryModal}>Last Updated</button>
                  </div>
                </div>
              </div>
            </>}
          </div>
          
        </div>



        {seedfundResultView ? <>
          <Refresh
            onClickRefresh={refreshStatupList}
            className=""
          />
          <div className='entity-details-box'>
            <div className='entity-heading'>Entity Details</div>
            <div className='row p18'>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Recognition No"
                  value={certificateNumber}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Incorporation Date"
                  value={incorporationDate}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Incorporation No."
                  value={incorporationNumber}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
              <div className='col-xl-3 col-12 col-md-6 col-sm-12'>
                <InputField
                  required
                  type="text"
                  name="diiptNumber"
                  label="Name of Entity"
                  value={nameOfEntity}
                  containerClass={"form-group"}
                  disabled
                />
              </div>
            </div>
          </div>
          {/* <div className='row mt-2 mb-2 mt-4 justify-content-end ml-0 mr-0 entity-row'>
            <div className='col-md-3'>
              <div onClick={handleOpenSelectDropdown}
                className={`download-container bttn dropdown-check dropdown-check-list ${openSelectDropdown ? 'show' : ""}`}
              >
                {select}    <img width="15px" src={downArrowBtnblack} className='showicon-black' />
                <img src={downArrowBtn} width="15px" className='showicon-white' />
                <ul>
                  <li >
                    <div className="form-check">
                      <input className="form-check-input" type="radio" value={'Winner'} id={`checkbox-${'Winner'}`} name="selectBy" onChange={(event) => handleSelectBy(event, 'Winner')}  />
                      <label className="form-check-label" htmlFor={`checkbox-${'Winner'}`} >
                        Winner
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" value={'Finalist'} id={`checkbox-${'Finalist'}`} name="selectBy" onChange={(event) => handleSelectBy(event, 'Finalist')} />
                      <label className="form-check-label" htmlFor={`checkbox-${'Finalist'}`} >
                        Finalist
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3'>
              <div onClick={handleOpenNSAYearDropdown}
                className={`download-container bttn dropdown-check dropdown-check-list ${openNSAYearDropdown ? 'show' : ""}`}
              >
                {nsaYear}    <img width="15px" src={downArrowBtnblack} className='showicon-black' />
                <img src={downArrowBtn} width="15px" className='showicon-white' />
                <ul>
                  {nsaYearArray?.map((el) => (<li key={el} >
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value={el}
                        id={`checkbox-${el}`}
                        name="nsaYear"
                        onChange={(event) => handleNSAYear(event, el)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${el}`}
                      //  onClick={(event) => handleNSAYear(event, el)}
                      >
                        {el}
                      </label>
                    </div>
                  </li>))}


                </ul>


              </div>
            </div>
            <div className='col-md-2 p-0 pding15'>
              <div className="button-wrap">
                <Button
                  className="bttn submit-bnt"
                  type="submit"
                  text="Save"
                  onClick={handleSubmit}
                  disabled={saveDisable}
                />
              </div>
            </div>
          </div> */}
        </> : <>
          <div className='row' style={{ marginTop: '15px' }}>

            <div className='col-sm-12 mt-3 w-100' style={{ paddingRight: '24px' }}>
              <Download
                fileName={'SeedFund Result Details'}
                onClickDownload={downloadSeedfundResultList}
                className="bttn-link"
              />
            </div>
          </div>
          <Table
            dataTable={data}
            columns={columns({
              clickOnAction,
              pageNo: pageNo,
              size: sizePerPage
            })}
            keyField='applicationId'
            onSortChange={onSortChange}
            totalSize={recordsTotal}
            rowStyle={rowStyle2}
            sizePerPage={sizePerPage}
            onPageChange={handleOnPageChange}
            onSizePerPageChange={handleOnSizePerPageChange}
            actionHandler={actionHandler}
          /></>}
      </div>
      <Modal isOpen={openHistory} toggle={closeHistoryModal} className="last-generated-report">
                <ModalHeader toggle={closeHistoryModal}>
                    Last Updated
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className='last-generated seed-fund'>
                            <ul>
                                {/* <li><strong>Name : </strong> <p>{historyData['adminName']}</p></li>
                                <li><strong>Action : </strong> <p>{historyData['action']}</p></li>
                                <li><strong>Action Date : </strong> <p>{moment(historyData['actionDate']).format('DD/MM/YYYY')}</p></li> */}
                                <li><strong>Last Updated : </strong> <p>{moment().startOf('day').subtract(1, 'day').format('YYYY-MM-DD 12:00 A')}</p></li>
                                <li><strong>Type : </strong> <p>Dynamic</p></li>
                            </ul>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className="button-container">
                        <button className="download-container downloadReport-Generated" onClick={(event) => closeHistoryModal(event)}>
                            Ok
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    seedfundReportDataState: state.seedfundReportList.seedfundReportData
  }
}

export default connect(mapStateToProps, { getSeedfundReportList, doDownloadResultList, lastGeneratedReportHistory })(withRouter(SeedFund));